import 'slick-carousel/slick/slick.min'

$(document).ready(function () {
	$('.la-familia-slider').slick({
		arrows: true,
		slidesToShow: 3,
		infinite: true,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '60px',
		autoplay: true,
		autoplaySpeed: 3000,

		responsive: [
			{
				breakpoint: 1080,
				settings: {
					slidesToShow: 3,
					centerPadding: '30px',
					slidesToScroll: 1,
					centerMode: true,
					arrows: true,
				},
			},

			// {
			// 	breakpoint: 1740,
			// 	settings: {
			// 		slidesToShow: 5,
			// 		slidesToScroll: 1,
			// 		infinite: true,
			// 		centerMode: true,
			// 	},
			// },
			// {
			// 	breakpoint: 1250,
			// 	settings: {
			// 		slidesToShow: 3,
			// 		slidesToScroll: 1,
			// 		infinite: true,
			// 		centerMode: true,
			// 	},
			// },
			{
				breakpoint: 945,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerPadding: '20px',
					centerMode: true,
				},
			},
			{
				breakpoint: 720,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: false,
				},
			},
			{
				breakpoint: 490,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '50px',
					arrows: false,
				},
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	})

	var famalia_filtered = false

	$('.filters').on('click', function (event) {
		event.preventDefault()
		// get the id of the clicked link
		var whichID = $(this).attr('id')

		//remove selected class from all buttons
		$('.filters').removeClass('selected')

		//add selected class only to clicked button
		$(this).addClass('selected')

		// If the the 'all' link, remove filtered class and show all.
		if (whichID != 'filter-all') {
			if ($('.la-familia-slider').hasClass('filtered')) {
				$('.la-familia-slider').slick('slickUnfilter')
				$('.la-familia-slider').slick('slickGoTo', 0)
				famalia_filtered = false
			} else {
				$('.la-familia-slider').addClass('filtered')
			}

			if (whichID === 'js-filter-spirits') {
				if (famalia_filtered === false) {
					$('.la-familia-slider').slick('slickFilter', '.spirits')
					$('.la-familia-slider').slick('slickGoTo', 0)
					famalia_filtered = true
				} else {
					$('.la-familia-slider').slick('slickUnfilter')
					$('.la-familia-slider').slick('slickGoTo', 0)
					famalia_filtered = false
				}
			} else if (whichID === 'js-filter-brand') {
				if (famalia_filtered === false) {
					$('.la-familia-slider').slick('slickFilter', '.brand')
					$('.la-familia-slider').slick('slickGoTo', 0)
					famalia_filtered = true
				} else {
					$('.la-familia-slider').slick('slickUnfilter')
					$('.la-familia-slider').slick('slickGoTo', 0)
					famalia_filtered = false
				}
			}
		} else {
			$('.la-familia-slider').removeClass('filtered')
			$('.la-familia-slider').slick('slickUnfilter')
			$('.la-familia-slider').slick('slickGoTo', 0)
		}
	})

	$('.news-slider').slick({
		arrows: true,
		slide: '.news-item',
		slidesToShow: 1,
		slidesToScroll: 1,
		centerPadding: '25%',
		centerMode: true,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 3000,

		responsive: [
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerPadding: '400px',
				},
			},
			{
				breakpoint: 1440,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerPadding: '300px',
				},
			},
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerPadding: '20px',
				},
			},
			{
				breakpoint: 490,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '10px',
					arrows: false,
				},
			},
		],
	})

	var filtered = false

	$('.filters').on('click', function (event) {
		event.preventDefault()
		// get the id of the clicked link
		var whichID = $(this).attr('id')

		//remove selected class from all buttons
		$('.filters').removeClass('selected')

		//add selected class only to clicked button
		$(this).addClass('selected')

		// If the the 'all' link, remove filtered class and show all.
		if (whichID != 'js-filter-all') {
			if ($('.news-slider').hasClass('filtered')) {
				$('.news-slider').slick('slickUnfilter')
				$('.news-slider').slick('slickGoTo', 0)
				filtered = false
			} else {
				$('.news-slider').addClass('filtered')
			}

			if (whichID === 'js-filter-news') {
				if (filtered === false) {
					$('.news-slider').slick('slickFilter', '.news')
					$('.news-slider').slick('slickGoTo', 0)
					filtered = true
				} else {
					$('.news-slider').slick('slickUnfilter')
					$('.news-slider').slick('slickGoTo', 0)
					filtered = false
				}
			} else if (whichID === 'js-filter-recipes') {
				if (filtered === false) {
					$('.news-slider').slick('slickFilter', '.recipes')
					$('.news-slider').slick('slickGoTo', 0)
					filtered = true
				} else {
					$('.news-slider').slick('slickUnfilter')
					$('.news-slider').slick('slickGoTo', 0)
					filtered = false
				}
			} else if (whichID === 'js-filter-events') {
				if (filtered === false) {
					$('.news-slider').slick('slickFilter', '.event')
					$('.news-slider').slick('slickGoTo', 0)
					filtered = true
				} else {
					$('.news-slider').slick('slickUnfilter')
					$('.news-slider').slick('slickGoTo', 0)
					filtered = false
				}
			}
		} else {
			$('.news-slider').removeClass('filtered')
			$('.news-slider').slick('slickUnfilter')
			$('.news-slider').slick('slickGoTo', 0)
		}
	})

	$('.related-slider').slick({
		arrows: true,
		slidesToShow: 6,
		infinite: true,
		slidesToScroll: 1,
		// autoplay: true,
		// autoplaySpeed: 3000,

		responsive: [
			// {
			// 	breakpoint: 1200,
			// 	settings: {
			// 		slidesToShow: 1,
			// 		slidesToScroll: 1,
			// 		centerMode: true,
			// 		arrows: false,
			// 	},
			// },

			// {
			// 	breakpoint: 1740,
			// 	settings: {
			// 		slidesToShow: 5,
			// 		slidesToScroll: 1,
			// 		infinite: true,
			// 		centerMode: true,
			// 	},
			// },
			// {
			// 	breakpoint: 1250,
			// 	settings: {
			// 		slidesToShow: 3,
			// 		slidesToScroll: 1,
			// 		infinite: true,
			// 		centerMode: true,
			// 	},
			// },
			{
				breakpoint: 945,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
				},
			},
			// {
			// 	breakpoint: 720,
			// 	settings: {
			// 		slidesToShow: 2,
			// 		slidesToScroll: 1,
			// 		centerMode: false,
			// 	},
			// },
			{
				breakpoint: 490,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					arrows: false,
				},
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	})
})
